import Vue from 'vue'
import { Storage } from '@/modules/plugins/storage'
import VueCookies from 'vue-cookies'
import jwt_decode from 'jwt-decode'
Vue.use(VueCookies)

Vue.$cookies.config(
    '30d',
    undefined,
    window.location.hostname,
    window.location.protocol.includes('https')
)

class DataStorage {
    constructor() {}

    get user() {
        return Storage.getItem('authUser') || {}
    }

    set user(val) {
        if (val) Storage.setItem('authUser', JSON.stringify(val))
        else Storage.removeItem('authUser')
    }

    get accessToken() {
        return Vue.$cookies.get('authAccessToken') || null
    }

    set accessToken(token) {
        if (token) {
            Vue.$cookies.set('authAccessToken', token, new Date(jwt_decode(token).exp * 1000))
            this.expiresAt = jwt_decode(token).exp * 1000
        } else {
            Vue.$cookies.remove('authAccessToken')
            this.expiresAt = undefined
        }
    }

    get tokenType() {
        return Vue.$cookies.get('authTokenType') || null
    }

    set tokenType(type) {
        if (type) Vue.$cookies.set('authTokenType', type)
        else Vue.$cookies.remove('authTokenType')
    }

    get refreshToken() {
        return Vue.$cookies.get('authRefreshToken') || null
    }

    set refreshToken(token) {
        if (token) Vue.$cookies.set('authRefreshToken', token)
        else Vue.$cookies.remove('authRefreshToken')
    }

    get expiresAt() {
        return Vue.$cookies.get('authExpiresAt') || null
    }

    set expiresAt(expires) {
        if (expires) Vue.$cookies.set('authExpiresAt', expires)
        else Vue.$cookies.remove('authExpiresAt')
    }

    get headers() {
        if (this.accessToken) return `${this.tokenType} ${this.accessToken}`
        return undefined
    }

    get notificationsAllowed() {
        let value = Storage.getItem('notificationsAllowed')
        return value === null ? value : Storage.getItem('notificationsAllowed') === 1
    }

    setNotificationsIgnoreFor2Week() {
        const date = new Date()
        date.setDate(date.getDate() + 14)
        return Vue.$cookies.set('notificationIgnore', 1, date)
    }

    get notificationsIsIgnoreByTime() {
        return !!Vue.$cookies.get('notificationIgnore')
    }

    set notificationsAllowed(val) {
        Storage.setItem('notificationsAllowed', val ? 1 : 0)
    }

    set notificationTypes(val) {
        if (val) Vue.$cookies.set('notificationTypes', JSON.stringify(val))
        else Vue.$cookies.remove('notificationTypes')
    }
}

export default DataStorage
